module.exports = __webpack_public_path__ + "static/media/woo.e978d4cf.svg";